import React, { Fragment, useEffect, useState } from 'react'
import Humberg from '../../elements/Humberg';
import { useDispatch, useSelector } from 'react-redux';
import LoaderBlock from '../loader/LoaderBlock';
import SingleOrder from './SingleOrder';
import DateFilter from '../../elements/DateFilter';

import TopBarValues from './topBarValues';
import Filters from './Filters';
import { allProductTypesAction, clearErrors } from '../../redux/actions/userActions';
import Loader from '../loader/loader';
import { toast } from 'react-toastify';
import { CREATE_ORDER_RESET } from '../../redux/constants/orderConstants';
import { multiMarkAsCompletedAction } from '../../redux/actions/orderActions';



/*************  ✨ Windsurf Command 🌟  *************/
const CommissionCalculation = () => {



    const dispatch = useDispatch()


    const { loading,
        orders,
        totalPages,
        commissionedCount,
    } = useSelector((state) => state.orders)

    const { user } = useSelector(state => state.verifyEmailStore);
    const { loading: orderLoading, error, message } = useSelector(state => state.order)




    const [page, setPage] = useState('1');
    const [dateFrom, setDateFrom] = useState('');
    const [dateTo, setDateTo] = useState('');
    const [pmmCommission, setPmmCommission] = useState(0);
    const [portalCommission, setPortalCommission] = useState(0);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [showPopup, setShowPopup] = useState(false);
    const [isMulti, setIsMulti] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');


    // Remove one quantity



    useEffect(() => {

        dispatch(allProductTypesAction())

    }, [dispatch])






    useEffect(() => {

        if (error) {
            toast.error(error)
            dispatch(clearErrors())
        }

        if (message) {
            if (isMulti) {
                setSuccessMessage(message)
            }
            setIsMulti(false)
            setShowPopup(false)
            setSelectedOrders([])
            dispatch({ type: CREATE_ORDER_RESET })
        }

    }, [error, message, dispatch, isMulti])



    useEffect(() => {


        if (orders?.length > 0) {

            let pmmTotal = 0;
            let portalTotal = 0;

            orders.forEach((order) => {

                pmmTotal = pmmTotal + Number(order?.pm_commission_amount) || 0;
                portalTotal = portalTotal + Number(order?.portal_commission_amount) || 0;
            })

            setPmmCommission(pmmTotal);
            setPortalCommission(portalTotal);
        }


    }, [orders])



    const handleDispatch = () => {


        dispatch(multiMarkAsCompletedAction({ order_ids: selectedOrders }))

        setIsMulti(true)

    }




    return (
        <Fragment>
            {orderLoading && <Loader />}
            <Humberg header="Dashboard" headerLink="/" children={user?.role === "PM" ? "Pending Commission" : "PM Pending"} />
            <DateFilter
                dateFrom={dateFrom}
                setDateFrom={setDateFrom}
                dateTo={dateTo}
                setDateTo={setDateTo}
            />
            <section className="p-[1.5vmax] mt-[1vmax]" >
                <TopBarValues
                    commissionedCount={commissionedCount}
                    pmmCommission={pmmCommission}
                    portalCommission={portalCommission}
                    totalOrders={orders?.length}

                />
                <Filters page={page} setPage={setPage} dateFrom={dateFrom} dateTo={dateTo} />
                <div className="bg-white flex justify-between items-center px-[2vmax] pt-[1.5vmax] pb-[1vmax] border-x border-zinc-100">
                    <div className="flex items-center gap-2">
                        <span className='text-[1.5vmax] lg:text-[0.9vmax] text-zinc-600 font-jakarta font-semibold' >Select All</span>
                        <input
                            type="checkbox"
                            className="w-4 h-4 text-indigo-600 border-zinc-300 rounded focus:ring-indigo-500 cursor-pointer"
                            onChange={(e) => {
                                if (e.target.checked) {
                                    setSelectedOrders(orders.map(r => r.id));
                                } else {
                                    setSelectedOrders([]);
                                }
                            }}
                        />
                    </div>
                    {(user?.role === "SUPER_ADMIN" || user?.role === "ADMIN") && selectedOrders?.length > 0 && (

                        <button
                            className="bg-gradient-to-r from-indigo-600 to-indigo-700 text-white px-[1.5vmax] py-[0.6vmax] rounded-xl shadow-sm hover:shadow-md hover:from-indigo-700 hover:to-indigo-800 transition-all font-jakarta font-semibold text-[1.5vmax] lg:text-[0.9vmax] flex items-center gap-2"
                            onClick={() => setShowPopup(true)}
                        >
                            <i className="fa-solid fa-circle-check"></i>
                            Mark as COMPLETED ({selectedOrders.length})
                        </button>
                    )}
                </div>
                {successMessage &&

                    <div className="w-fit bg-emerald-50 border border-emerald-100 relative z-[1] text-emerald-700 flex gap-[1vmax] p-[0.6vmax_1.2vmax] rounded-xl text-[1.5vmax] lg:text-[0.9vmax] font-jakarta font-semibold mx-[2vmax] my-[1vmax] items-center">
                        <i className="fa-solid fa-circle-check text-emerald-500"></i>
                        <span>{successMessage}</span>
                        <button className="ml-2 text-emerald-400 hover:text-emerald-600 transition-colors" onClick={() => setSuccessMessage("")} ><i className="fa-xmark fa-solid"></i></button>
                    </div>
                }
                <div className="bg-white p-[2vmax] lg:mt-0 shadow-sm rounded-b-2xl border-x border-b border-zinc-100 overflow-x-auto my-scroll-2 my-scroll-3">

                    <div className="min-w-[1200px] mt-[2vmax] border border-gray-200 rounded-xl shadow-sm bg-white">
                        {/* Header */}
                        <div 
                            className="grid bg-gray-50 py-[1vmax] items-center border-b border-gray-200 rounded-t-xl"
                            style={{ gridTemplateColumns: user?.role !== 'PM' 
                                ? 'minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.2fr) minmax(0, 1.8fr) minmax(0, 1.5fr) minmax(0, 1.5fr)' 
                                : 'minmax(0, 0.7fr) minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1.5fr) minmax(0, 1.2fr) minmax(0, 1.8fr) minmax(0, 1.5fr) minmax(0, 1.5fr)' }}
                        >
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                Select
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                Order ID
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                Product ID
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                Ordered By
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                PM Earnings
                            </div>
                            {user?.role !== "PM" &&
                                <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                    Portal Earnings
                                </div>
                            }
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                Commissioned At
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                Status
                            </div>
                            <div className="text-center text-[#4c4c5c] uppercase text-[1.3vmax] lg:text-[0.9vmax] font-bold" >
                                Actions
                            </div>
                        </div>

                        {/* Rows */}
                        {loading ?
                            <LoaderBlock />
                            :
                            orders?.length > 0 ?
                                orders.map((order) => (
                                    <SingleOrder key={order.id} order={order} user={user} selectedOrders={selectedOrders} setSelectedOrders={setSelectedOrders} />
                                ))
                                :
                                <div className="text-center text-[1.5vmax] text-gray-400 py-[3vmax]" >
                                    No data found
                                </div>
                        }
                    </div>
                </div>
            </section>
            {totalPages > 1 && (
                <div className="flex gap-[1vmax] justify-center mt-[2vmax]">

                    {/* Prev button */}
                    <button
                        className="pagination-btn"
                        disabled={page === 1}
                        onClick={() => setPage(page - 1)}
                    >
                        Prev
                    </button>

                    {/* --- SMART PAGINATION START --- */}
                    {(() => {
                        const pages = [];
                        const maxVisible = 3; // number of pages to show around current page

                        const addPage = (p) => {
                            pages.push(
                                <button
                                    key={p}
                                    className={`pagination-btn ${page === p ? "active" : ""}`}
                                    onClick={() => setPage(p)}
                                >
                                    {p}
                                </button>
                            );
                        };

                        // Always show First Page
                        addPage(1);

                        // Left dots
                        if (page > maxVisible + 2) {
                            pages.push(<span key="dots-left">...</span>);
                        }

                        // Middle pages (dynamic)
                        for (
                            let p = Math.max(2, page - maxVisible);
                            p <= Math.min(totalPages - 1, page + maxVisible);
                            p++
                        ) {
                            addPage(p);
                        }

                        // Right dots
                        if (page < totalPages - (maxVisible + 1)) {
                            pages.push(<span key="dots-right">...</span>);
                        }

                        // Always show Last Page
                        if (totalPages > 1) {
                            addPage(totalPages);
                        }

                        return pages;
                    })()}
                    {/* --- SMART PAGINATION END --- */}

                    {/* Next button */}
                    <button
                        className="pagination-btn"
                        disabled={page === totalPages}
                        onClick={() => setPage(page + 1)}
                    >
                        Next
                    </button>

                </div>
            )}

            {showPopup && (
                <div className="fixed inset-0 flex-center bg-zinc-900/50 backdrop-blur-sm z-[99999999999] p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden border border-zinc-100 transform transition-all p-6">
                        
                        {/* Icon */}
                        <div className="mx-auto w-12 h-12 rounded-full bg-indigo-50 text-indigo-600 flex-center text-2xl mb-4">
                            <i className="fa-solid fa-circle-question"></i>
                        </div>

                        {/* Content */}
                        <div className="text-center">
                            <h3 className="font-bold text-lg text-zinc-800 font-jakarta mb-2">
                                Mark as Commissioned
                            </h3>
                            <p className="text-sm text-zinc-500 leading-relaxed whitespace-pre-line">
                                By marking this order as Commissioned, you confirm that the order has been successfully completed and the commission can be processed. Please ensure all necessary steps have been taken and the order is ready for commissioning before proceeding.
                            </p>
                        </div>

                        {/* Buttons */}
                        <div className="flex gap-3 mt-6">
                            <button
                                className="flex-1 text-zinc-600 font-semibold py-2.5 px-4 rounded-xl border border-zinc-200 hover:bg-zinc-50 transition-all active:scale-[0.98]"
                                onClick={() => setShowPopup(false)}
                            >
                                No
                            </button>
                            <button
                                className="flex-1 bg-gradient-to-r from-indigo-600 to-indigo-700 text-white font-semibold py-2.5 px-4 rounded-xl hover:shadow-lg hover:shadow-indigo-100 transition-all active:scale-[0.98]"
                                onClick={handleDispatch}
                            >
                                Yes, Proceed
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <br />
            <br />
            <br />
            <br />
        </Fragment>
    )
}

export default CommissionCalculation